module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "selecter",
    on: {
      "mouseleave": _vm.close
    }
  }, [_c('span', {
    attrs: {
      "title": _vm.selecterText
    },
    on: {
      "click": _vm.showPanel
    }
  }, [_vm._v(_vm._s(_vm.selecterText))]), _vm._v(" "), _c('ul', {
    staticClass: "panel",
    class: {
      'showPanel': _vm.showSelecter
    }
  }, [_c('li', {
    class: {
      'isShow': !_vm.autoIsShow
    },
    on: {
      "click": function($event) {
        _vm.selected(-1)
      }
    }
  }, [_vm._v("---全部---")]), _vm._v(" "), _vm._l((_vm.selectData), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.selected(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae6cb008","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/selecter/selecter.vue
// module id = 1240
// module chunks = 1